var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReports01 = function SvgIconReports01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_reports-01_svg2__a",
    x1: -0.71,
    x2: 74.12,
    y1: 97.21,
    y2: 25.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_reports-01_svg2__a",
    id: "icon_reports-01_svg2__b",
    x1: -0.39,
    x2: 74.43,
    y1: 97.54,
    y2: 25.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_reports-01_svg2__a",
    id: "icon_reports-01_svg2__c",
    x1: 21.1,
    x2: 95.92,
    y1: 119.87,
    y2: 47.87
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.83 51.37V6.25c0-1.15-.93-2.08-2.08-2.08C19.63 4.17 0 25.66 0 52.08S21.5 100 47.92 100c11.82 0 18.22-2.14 26.33-8.81.87-.72 1.01-2 .32-2.89L45.84 51.37Zm2.09 44.46C23.8 95.83 4.17 76.2 4.17 52.08S20.8 9.6 41.67 8.39v43.69c0 .46.15.91.44 1.28l27.9 35.87c-6.58 5.03-12.07 6.6-22.09 6.6",
    style: {
      fill: "url(#icon_reports-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.08 50h45.83c1.15 0 2.08-.93 2.08-2.08C100 21.5 78.5 0 52.08 0 50.93 0 50 .93 50 2.08v45.83c0 1.15.93 2.08 2.08 2.08Zm2.09-45.78c22.47 1.06 40.56 19.15 41.62 41.62H54.17z",
    style: {
      fill: "url(#icon_reports-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.92 54.17H56.25c-.8 0-1.54.46-1.88 1.19-.35.73-.24 1.58.26 2.2l27.08 33.53c.36.45.9.73 1.47.77h.15c.52 0 1.03-.2 1.42-.56C94.44 82.26 100 69.49 100 56.25c0-1.15-.93-2.08-2.08-2.08",
    style: {
      fill: "url(#icon_reports-01_svg2__c)"
    }
  }));
};
export default SvgIconReports01;